module.exports = __webpack_public_path__ + "static/media/carrsqc.c2ab4126.svg";